module.exports = __webpack_public_path__ + "assets/img/code-gzh-aacc8463.png";